import { FC, ReactNode } from "react";

export interface SectionHeroProps {
  className?: string;
  aboutUs: any;
}

const SectionAbout: FC<SectionHeroProps> = ({ className = "", aboutUs }) => {
  const { image_url, heading, description, width, height, alignment } = aboutUs;
  return (
    <div
      className={`nc-SectionHero relative ${className} rounded-md lg:pr-4 mb-20 lg:mb-36`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left lg:justify-between">
        <div className="flex-grow">
          <img
            className={`object-cover ${
              alignment === "right"
                ? "ml-auto"
                : alignment === "left"
                ? "mr-auto"
                : "mx-auto"
            }`}
            src={image_url}
            alt=""
            style={{ width: `${width}px`, height: `${height}px` }}
          />
        </div>
        <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-text-color md:text-4xl xl:text-5xl ">
            {heading}
          </h2>
          <span className="block !font-normal !text-md text-text-color break-words text-wrap">
            {description}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SectionAbout;
